import { render, staticRenderFns } from "./grid-box.vue?vue&type=template&id=486a41da&scoped=true"
import script from "./grid-box.vue?vue&type=script&lang=js"
export * from "./grid-box.vue?vue&type=script&lang=js"
import style0 from "./grid-box.vue?vue&type=style&index=0&id=486a41da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486a41da",
  null
  
)

export default component.exports